import { render } from "./ModalCrudObjetivosEstrategicos.vue?vue&type=template&id=77e6260f&scoped=true"
import script from "./ModalCrudObjetivosEstrategicos.vue?vue&type=script&lang=js"
export * from "./ModalCrudObjetivosEstrategicos.vue?vue&type=script&lang=js"

import "./ModalCrudObjetivosEstrategicos.vue?vue&type=style&index=0&id=77e6260f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e6260f"]])

export default __exports__